// extracted by mini-css-extract-plugin
export default {"modal-container":"style_modal-container__epNhr","modal-button":"style_modal-button__8CziO"};